import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles } from '@fluentui/react-components';
import { tokens } from './tokens.js';
import { shellMetrics, shellTokens } from './shell/tokens.js';
const useStyles = makeStyles({
    group: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: tokens.colorNeutralBackground3,
        borderRadius: tokens.borderRadiusLarge,
        overflow: 'hidden',
    },
    row: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: tokens.spacingHorizontalM,
        minHeight: shellMetrics.keyValueRow,
        padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
        borderTop: `${tokens.strokeWidthThin} solid ${shellTokens.divider}`,
        ':first-child': { borderTop: 'none' },
    },
    label: { color: shellTokens.text3, fontSize: tokens.fontSizeBase200, lineHeight: tokens.lineHeightBase200 },
    value: { color: shellTokens.text1, fontSize: tokens.fontSizeBase200, lineHeight: tokens.lineHeightBase200, fontWeight: tokens.fontWeightMedium, textAlign: 'right', minWidth: 0, overflowWrap: 'anywhere' },
});
export function KeyValueList({ items, 'aria-label': ariaLabel }) {
    const s = useStyles();
    return (_jsx("dl", { className: s.group, "aria-label": ariaLabel, style: { margin: 0 }, children: items.map((item) => (_jsxs("div", { className: s.row, children: [_jsx("dt", { className: s.label, children: item.label }), _jsx("dd", { className: s.value, style: { margin: 0 }, children: item.value })] }, item.label))) }));
}
//# sourceMappingURL=KeyValueList.js.map